import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function ChangeStatus() {
    return (
        <OnboardingBody title='How do I change my status?'>
            <div>
                <p>
                    To change your availability status, select your name in the bottom of the
                    navigation sidebar.
                    <br />
                    <br />
                    In the panel that slides out, look under your name and email for the
                    ‘availability’ option. Select it, and a pop-up will appear, allowing you to
                    update your status.
                </p>
            </div>
        </OnboardingBody>
    );
}
